import React, { useEffect, useState } from "react";
import { AdminGraphRow } from "./AdminGraphRow";
import { AdminTotalsTable } from "./AdminTotalsTable";
import { AdminWeekList } from "./AdminWeekList";
import { currentSearch, fetchAdminJson, LoadState } from "./adminApi";

export function AdminIndex() {
  const [state, setState] = useState<LoadState<any>>({ status: "loading" });

  useEffect(() => {
    fetchAdminJson<any>(`/overview${currentSearch()}`)
      .then((data) => setState({ status: "loaded", data }))
      .catch((error: Error) => setState({ status: "error", error: error.message }));
  }, []);

  if (state.status === "error") {
    return <div className="alert alert-danger">{state.error}</div>;
  }

  return (
    <>
      <AdminGraphRow />
      <AdminTotalsTable data={state.status === "loaded" ? state.data : undefined} />
      <AdminWeekList data={state.status === "loaded" ? state.data : undefined} />
    </>
  );
}
